import React, { forwardRef } from 'react';
const Button = forwardRef(function Button({ children, testId = 'store-button', ...otherProps }, ref) {
    return (React.createElement("button", Object.assign({ ref: ref, "data-store-button": true, "data-testid": testId }, otherProps), children));
});
export default Button;
//# sourceMappingURL=Button.js.map